import { useMemo } from "react";
import { useMyDataQuery } from "@/generated/graphql";

export const useHasFeature = (feature: string): boolean => {
  const { data: myData } = useMyDataQuery();

  return useMemo(() => {
    if (!myData?.myData?.subscription) {
      return false;
    }

    const subscription = myData?.myData?.subscription;
    const features = subscription?.plan?.features || [];
    return features.includes(feature);
  }, [myData?.myData?.subscription, feature]);
};
